import styled from "styled-components";

export const MainContainer = styled.div`
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center; 
  justify-content: center;
  background: var(--app-bg-gradient);
`;

export const ProfileContainerInfo = styled.div`  // Mudei de 'form' para 'div'
  display: flex;
  flex-direction: column;
  background: var(--app-bg-gradient);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  box-shadow: var(--shadow-sm);
  z-index: 2;
  width: ${({ collapsed }) => (collapsed ? "58vw" : "58vw")};
  margin: auto;
  margin-top: 4vh;
  position: relative;
  overflow: hidden;
  min-height: auto; /* Mude de 600px para auto */
  height: auto; /* Adicione esta linha */
  margin-bottom: 3vh;
  padding: ${({ isExpanded }) => (isExpanded ? "20px" : "0")}; /* Ajuste padding */

  h3 {
    display: flex;
    align-self: flex-start;
    color: var(--text-heading);
    margin: ${({ isExpanded }) => (isExpanded ? "0 0 20px 0" : "0")}; /* Ajuste margem */
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    max-width: 100%;
    margin-top: 3.25rem;
    box-sizing: border-box;
  }
`;

export const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  background: linear-gradient(135deg, var(--accent-secondary) 0%, var(--accent) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 2rem 0 0 0;
  text-shadow: 0 4px 20px var(--accent-secondary-soft);
  text-align: center;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const FormContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex-wrap: wrap;
  padding: 2.5rem;
  border-radius: 20px;
  margin: auto;

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

export const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.26vw;
  width: 50%;

  @media screen and (max-width: 768px) {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    margin-left: 0 !important;
    box-sizing: border-box;
  }
`;

export const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.26vw;
  width: 50%;

  @media screen and (max-width: 768px) {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    margin-left: 0 !important;
    box-sizing: border-box;
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 0.25vh;
  height: 6vw;
`;

export const Label = styled.label`
  color: var(--text-heading);
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 0.5rem;
  display: block;
  position: relative;
  z-index: 2;
`;

export const ShowInput = styled.input`
  width: 23.2vw;
  height: 1.2vw;
  padding: 0.8vw 0.8vw;
  border: 2px solid var(--border-default);
  border-radius: 12px;
  font-size: 14px;
  outline: none;
  background: var(--input-bg);
  color: var(--text-primary);
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  position: relative;
  z-index: 2;

  &::placeholder {
    color: var(--input-placeholder);
  }

  &:focus {
    border-color: var(--accent);
    background: var(--input-bg-focus);
    box-shadow: 0 0 0 3px var(--accent-soft);
  }

  @media screen and (max-width: 768px) {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    height: auto !important;
    min-height: 44px;
    padding: 0.7rem 0.85rem !important;
    font-size: 16px;
    box-sizing: border-box;
  }
`;

export const StyledSelect = styled.select`
  width: 25vw;
  height: 3vw;
  padding: 0.8vw 0.8vw;
  padding-right: 50px; // Aumenta o espaço para a seta + margem
  border: 2px solid var(--border-default);
  border-radius: 12px;
  font-size: 14px;
  outline: none;
  background: var(--input-bg);
  color: var(--text-primary);
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  cursor: pointer;
  position: relative;
  z-index: 2;
  
  // Remove as propriedades de direção RTL
  text-align: left;
  direction: ltr;

  // Custom arrow (seta personalizada) na direita com margem
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%2300b056'%3e%3cpath d='M7 10l5 5 5-5z'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 20px center; // Seta na direita com margem
  background-size: 20px;

  option {
    background: var(--surface-1);
    color: var(--text-primary);
  }

  &:focus {
    border-color: var(--accent);
    background: var(--input-bg-focus);
    box-shadow: 0 0 0 3px var(--accent-soft);
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    padding-right: 45px;
    background-position: right 15px center;
  }
`;

export const TextArea = styled.textarea`
  width: 80%;
  height: 80px;
  min-height: 80px;
  border-radius: 12px;
  padding: 16px;
  font-size: 14px;
  outline: none;
  background: var(--input-bg);
  transition: all 0.3s ease-in-out;
  color: var(--text-primary);
  border: 2px solid var(--border-default);
  resize: vertical;
  
  /* Centralização */
  display: block;
  margin: 10px auto 0 30px;
  
  /* Para alinhar com outros inputs do formulário */
  font-family: inherit;

  &:focus {
    border-color: var(--accent);
    background: var(--input-bg-focus);
    color: var(--text-primary);
    box-shadow: 0 0 0 3px var(--accent-soft);
    transform: translateY(-1px);
  }

  &:hover:not(:focus) {
    border-color: var(--border-strong);
    background: var(--input-bg-focus);
  }

  &::placeholder {
    color: var(--input-placeholder);
    font-size: 13px;
  }

  @media screen and (max-width: 768px) {
    width: 95%;
    max-width: none;
    min-width: unset;
    height: 70px;
    min-height: 70px;
    padding: 12px;
    font-size: 13px;
    margin: 0 auto 16px auto;
  }

  @media screen and (max-width: 480px) {
    width: 100%;
    height: 65px;
    min-height: 65px;
    padding: 10px;
    font-size: 12px;
  }
`;

export const HiddenFileInput = styled.input`
  display: none;
`;

export const ArquivoAtual = styled.label`
  font-size: 80%;
  color: var(--info);
`;

export const ArquivoEscolhido = styled.label`
  font-size: 80%;
  color: var(--danger);
`;


export const StyledAddArea = styled.button`
  height: 4rem;
  width: 80%;
  background-color: var(--surface-2);
  color: var(--text-muted);
  border: 2px dashed var(--border-default);
  border-radius: 100px;
  box-shadow: var(--shadow-sm);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif;
  padding: 6px 10px;
  text-align: center;
  text-decoration: none;
  transition: all 250ms ease;
  font-size: 0.9rem;
  font-weight: 500;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  z-index: 1;
  position: relative;
  overflow: hidden;

  &::after {
    content: '+';
    font-size: 1.5rem;
    font-weight: 300;
    margin-left: 8px;
    color: var(--text-muted);
    transition: all 250ms ease;
  }

  &:hover {
    background-color: var(--surface-3);
    border-color: var(--border-strong);
    border-style: solid;
    color: var(--text-secondary);
    transform: translateY(-2px);
    box-shadow: var(--shadow-md);

    &::after {
      transform: rotate(90deg) scale(1.1);
      color: var(--text-secondary);
    }
  }

  &:active {
    transform: translateY(0);
    background-color: var(--surface-3);
    box-shadow: var(--shadow-sm);
    transition: all 100ms ease;
  }

  &:focus {
    outline: none;
    border-color: var(--accent);
    box-shadow: 0 0 0 3px var(--accent-soft);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background-color: var(--surface-2);
    border-color: var(--border-subtle);
    color: var(--text-muted);
    
    &:hover {
      transform: none;
      border-color: var(--border-subtle);
      background-color: var(--surface-2);
      box-shadow: var(--shadow-sm);
    }
    
    &::after {
      color: var(--text-muted);
    }
  }

  @media (max-width: 768px) {
    width: 90%;
    height: 3.5rem;
    font-size: 0.85rem;
    
    &::after {
      font-size: 1.3rem;
      margin-left: 6px;
    }
  }
`;

export const FileInputWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

export const FileInputButton = styled.label`
  width: 23.2vw;
  height: 1.2vw;

  padding: 0.8vw 0.8vw;
  border: 2px solid var(--border-default);
  border-radius: 12px;
  font-size: 14px;
  outline: none;
  background: var(--input-bg);
  color: var(--text-primary);
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  cursor: pointer;
  position: relative;
  z-index: 2;
  
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    border-color: var(--border-strong);
    background: var(--input-bg-focus);
  }

  &:focus {
    border-color: var(--accent);
    background: var(--input-bg-focus);
    box-shadow: 0 0 0 3px var(--accent-soft);
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    height: auto;
    padding: 12px;
  }
`;

export const SmallText = styled.small`
  color: var(--text-muted);
  margin-bottom: 8px;
`;

export const StyledButtonSalvar = styled.button`
  background: ${props => props.secondary 
    ? 'var(--surface-glass)' 
    : 'var(--accent-secondary-soft)'};
  border: 2px solid ${props => props.secondary 
    ? 'var(--border-default)' 
    : 'var(--border-default)'};
  border-radius: 16px;
  color: ${props => props.secondary 
    ? 'var(--text-primary)' 
    : 'var(--text-heading)'};
  cursor: pointer;
  padding: 12px 24px;
  text-align: center;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 14px;
  font-weight: 500;
  backdrop-filter: blur(10px);
  position: relative;
  overflow: hidden;
  min-width: 140px;
  min-height: 44px;
  z-index: 2;

  &:hover {
    transform: translateY(-3px);
    border-color: ${props => props.secondary 
      ? 'var(--border-strong)' 
      : 'var(--accent)'};
    color: var(--text-primary);
    box-shadow: var(--shadow-md);
  }

  &:active {
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }

  @media screen and (max-width: 768px) {
    min-width: 120px;
    padding: 10px 20px;
  }
`;

export const StyledButtonDeletar = styled.button`
  background: ${props => props.secondary 
    ? 'var(--surface-glass)' 
    : 'var(--danger-soft)'};
  border: 2px solid ${props => props.secondary 
    ? 'var(--border-default)' 
    : 'var(--danger)'};
  border-radius: 16px;
  color: ${props => props.secondary 
    ? 'var(--text-primary)' 
    : 'var(--danger)'};
  cursor: pointer;
  padding: 12px 24px;
  text-align: center;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 14px;
  font-weight: 500;
  backdrop-filter: blur(10px);
  position: relative;
  overflow: hidden;
  min-width: 140px;
  min-height: 44px;
  z-index: 2;

  &:hover {
    transform: translateY(-3px);
    border-color: var(--danger);
    color: var(--text-primary);
    box-shadow: var(--shadow-md);
  }

  &:active {
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }

  @media screen and (max-width: 768px) {
    min-width: 120px;
    padding: 10px 20px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  width: 100%;
  margin-top: 20px;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const Span = styled.span`
  color: var(--text-secondary);
  font-size: 75%;
`;

export const ButtonLink = styled.button`
  background: none;
  border: none;
  color: var(--info);
  cursor: pointer;
  font: inherit;
  padding: 0;
  text-decoration: underline;
  font-weight: 400;
  font-size: 14px;
  text-decoration: none;
  margin-left: 170px;

  &:hover {
    color: var(--accent);
    text-decoration: none;
  }
`;

export const StyledButtonConfirmar = styled.button`
  background-color: var(--accent);
  border-radius: 100px;
  box-shadow: var(--shadow-sm);
  color: var(--text-on-brand);
  cursor: pointer;
  display: inline-block;
  font-family: CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif;
  padding: 6px 10px;
  text-align: center;
  text-decoration: none;
  transition: all 250ms;
  border: 0;
  font-size: 75%;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  width: 7vw;
  height: 5vh;
  z-index: 1;

  :hover {
    background-color: var(--accent-hover);
    box-shadow: var(--shadow-md);
    transform: scale(1.05);
  }

  @media screen and (max-width: 768px) {
    font-size: 12px;
    width: 130px;
    height: 30px;
  }
`;

export const StyledButtonVoltar = styled.button`
  background: ${props => props.secondary 
    ? 'var(--surface-glass)' 
    : 'var(--accent-secondary-soft)'};
  border: 2px solid var(--border-default);
  border-radius: 16px;
  color: ${props => props.secondary 
    ? 'var(--text-primary)' 
    : 'var(--text-heading)'};
  cursor: pointer;
  padding: 12px 24px;
  text-align: center;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 14px;
  font-weight: 500;
  backdrop-filter: blur(10px);
  position: relative;
  overflow: hidden;
  min-width: 140px;
  min-height: 44px;
  z-index: 2;

  &:hover {
    transform: translateY(-3px);
    border-color: var(--accent);
    color: var(--text-primary);
    box-shadow: var(--shadow-md);
  }

  &:active {
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }

  @media screen and (max-width: 768px) {
    min-width: 120px;
    padding: 10px 20px;
  }
`;